/** Stable references for default prop fallbacks (avoid new [] / {} per render). */
export const EMPTY_ARRAY = Object.freeze([]);
export const EMPTY_OBJECT = Object.freeze({});
